import styled from 'styled-components';

const StyledInfoMenu = styled.div`
  position: absolute;
  right: 10px;
  width: 290px;
  max-height: 350px;
  overflow-y: scroll;
  background-color: #fff;
  color: #000;
  font-size: 16px;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgb(0 0 0 / 20%);
`;

export default StyledInfoMenu;